import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { Banco } from './banco.model';
import { NTECH_API } from '../app.api';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-banco',
  templateUrl: './banco.component.html',
  styleUrls: ['./banco.component.css']
})
export class BancoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  listaBanco: CustomStore;
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  colunasGridBanco = [
    {
      dataField: 'Id',
      dataType: 'string',
      caption: 'ID',
      editorOptions: { disabled: true }
    },
    {
      dataField: 'DescricaoBanco',
      dataType: 'string',
      caption: 'Descrição',
      validationRules: [{
        type: 'required',
        message: 'Descrição é obrigatório.'
      }]
    }
  ];

  editOptionsGridBanco = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Banco',
      showTitle: true
    }
  };

  constructor(@Inject(Http) http: Http) {
    this.listaBanco = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/banco/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/banco/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/banco/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/banco/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }
}



// WEBPACK FOOTER //
// ./src/app/banco/banco.component.ts